



























import {
  defineComponent,
  getCurrentInstance,
  PropType,
} from '@vue/composition-api'

import ExportImportButton from '@/components/molecules/h/ExportImportButton.vue'
import ExtractCondition from '@/components/organisms/h/page/common/item-feature/ExtractCondition.vue'
import OutputCondition from '@/components/organisms/h/page/common/item-feature/OutputCondition.vue'
import TitleAndManipulate from '@/components/organisms/h/TitleAndManipulate.vue'
import {
  outputCondUseInfoList,
  ItemFeatureOutputCondition,
  ItemFeatureExtractCondition,
} from '@/types/entities'

export default defineComponent({
  components: {
    TitleAndManipulate,
    ExtractCondition,
    OutputCondition,
    ExportImportButton,
  },
  props: {
    outputUseList: {
      type: Array as PropType<outputCondUseInfoList>,
      default: () => [],
    },
    totalCount: {
      type: String as PropType<string>,
      default: null,
    },
    exportSpinner: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  setup(_, context) {
    const instance = getCurrentInstance()
    if (!instance) {
      // should be called in setup
      return
    }
    const { $i18n } = instance.proxy

    const requestExport = () => {
      context.emit('request-export')
    }
    const requestImport = () => {
      context.emit('request-import')
    }
    const changeOutputCondition = (cond: ItemFeatureOutputCondition) => {
      context.emit('change-output-condition', cond)
    }
    const changeExtractCondition = (cond: ItemFeatureExtractCondition) => {
      context.emit('change-extract-condition', cond)
    }
    return {
      requestExport,
      requestImport,
      changeOutputCondition,
      changeExtractCondition,
    }
  },
})
